// EcoClean — Configuración
// ⚠️ COMPLETAR: whatApp number con código de país, sin + ni espacios

const WHATSAPP_NUMBER = '5492954474697';

const WA = (msg) => `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;

export const CONTACT = {
  businessName: 'EcoClean',
  address: 'Avda. Uruguay 785',
  city: 'Santa Rosa',
  province: 'La Pampa',
  fullAddress: 'Avda. Uruguay 785, Santa Rosa, La Pampa',
  instagram: 'https://www.instagram.com/ecocleanlp/',
  instagramHandle: '@ecocleanlp',
  mapLat: -36.625245,
  mapLng: -64.301545,
};

export const WHATSAPP = {
  number: WHATSAPP_NUMBER,
  url: WA('¡Hola EcoClean! Quiero consultar sobre sus productos de limpieza sustentable.'),
  product: (name) => WA(`¡Hola EcoClean! Quiero consultar sobre ${name}. ¿Me dan más información?`),
  need: (key) => {
    const msgs = {
      blanquear_ropa: '¡Hola EcoClean! Quiero asesoramiento para blanquear ropa y sacar manchas. ¿Qué producto me recomiendan?',
      sacar_manchas: '¡Hola EcoClean! Tengo manchas difíciles en la ropa. ¿Qué producto me recomiendan?',
      limpiar_bano: '¡Hola EcoClean! Quiero productos para limpiar el baño de forma natural. ¿Qué me recomiendan?',
      desengrasar_cocina: '¡Hola EcoClean! Necesito algo para desengrasar la cocina sin químicos agresivos.',
      sacar_olores: '¡Hola EcoClean! Busco cómo sacar olores de forma natural. ¿Qué producto me sirve?',
      empezar: '¡Hola EcoClean! Quiero empezar con limpieza sustentable. ¿Qué productos me recomiendan para arrancar?',
    };
    return WA(msgs[key] || msgs.empezar);
  },
  education: (product) => WA(`¡Hola EcoClean! Quiero saber cómo usar ${product} correctamente.`),
};
